let overlay;

function createOverlay(image) {
  overlay = document.createElement('div');
  overlay.classList.add('image-magnify-full-size');
  overlay.style.backgroundImage = `url('${image.src}')`;

  image.parentElement.style.position = 'relative';
  image.parentElement.appendChild(overlay);
}

function moveWithHover(image, event, zoomRatio) {
  const rect = image.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / image.clientWidth) * 100;
  const y = ((event.clientY - rect.top) / image.clientHeight) * 100;

  overlay.style.backgroundPosition = `${x}% ${y}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  createOverlay(image);

  overlay.addEventListener('mousemove', (event) =>
    moveWithHover(image, event, zoomRatio)
  );

  overlay.addEventListener('mouseleave', () => overlay.remove());
  overlay.addEventListener('click', () => overlay.remove());
}

function enableZoom(zoomRatio) {
  const images = document.querySelectorAll('.product-zoom-image');

  images.forEach((image) => {
    image.style.cursor = 'zoom-in';
    image.addEventListener('click', (event) => {
      event.preventDefault();
      magnify(image, zoomRatio);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  enableZoom(2); // Zoom 2x
});
